__turbopack_context__.v({
  "chipList": "DgtxdG_chipList",
  "propertyFeatureContainer": "DgtxdG_propertyFeatureContainer",
});
